import { DetailBreadcrumbsComponent } from '@modules/common/components/detail-breadcrumbs/detail-breadcrumbs.component';
import { ContainerBadgeComponent } from '@modules/common/components/container-badge/container-badge.component';
import { SubtaskActionsComponent } from './components/task-form-subtasks/subtask-actions.component';
import { TaskDispositionComponent } from './components/task-form/task-disposition.component';
import { TaskWaitingComponent } from './components/task-form/task-waiting.component';
import { TaskWaitingMarkComponent } from '@modules/team-list-state/task-waiting-mark.component';
import { RowStatusMarkComponent } from '@modules/team-list-state/row-status-mark.component';
import { ItemReviewComponent } from '@modules/common/components/item-review/item-review.component';
import { HandoverAssignButtonComponent } from '@modules/common/components/item-handover/handover-assign-button.component';
import { TaskHandoverComponent } from './components/task-form/task-handover.component';
import { CanPurgeTeamItemPipe } from '@modules/common/pipes/can-purge-team-item.pipe';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Button2Component } from '@frontendlib/components/components/button/button2.component';
import { Checkbox2Component } from '@frontendlib/components/controls/checkbox/checkbox2.component';
import { ContextMenuDividerComponent } from '@frontendlib/components/features/popover/components/context-menu-divider/context-menu-divider.component';
import { ContextMenuHeadingComponent } from '@frontendlib/components/features/popover/components/context-menu-heading/context-menu-heading.component';
import { ContextMenuItemComponent } from '@frontendlib/components/features/popover/components/context-menu-item/context-menu-item.component';
import { ContextMenuStateIndicatorComponent } from '@frontendlib/components/features/popover/components/context-menu-state-indicator/context-menu-state-indicator.component';
import { DropdownInputComponent } from '@frontendlib/components/controls/dropdown-input/dropdown-input.component';
import { IconComponent } from '@frontendlib/components/components/icon/icon.component';
import { LoadingIndicatorComponent } from '@frontendlib/components/components/loading-indicator/loading-indicator.component';
import { NoContentStubComponent } from '@frontendlib/components/components/no-content-stub/no-content-stub.component';
import { PopoverDirective } from '@frontendlib/components/features/popover/directives/popover.directive';
import { SearchLocationBadgeComponent } from '@frontendlib/components/components/search-location-badge/search-location-badge.component';
import { ToggleSwitch2Component } from '@frontendlib/components/controls/toggle-switch/toggle-switch2.component';
import { BundledInputsModule } from '@modules/bundled-inputs/bundled-inputs.module';
import { CommentsModule } from '@modules/comments/comments.module';
import { InitialsCircleComponent } from '@modules/common/components/initials-circle/initials-circle.component';
import { ItemDescriptionFieldComponent } from '@modules/common/components/item-description/item-description-field.component';
import { ListItemSeparatorComponent } from '@modules/common/components/list/list-items-separator/list-items-separator.component';
import { ListLoadErrorComponent } from '@modules/common/components/list/list-load-error/list-load-error.component';
import { ListSelectionBarComponent } from '@modules/common/components/list/list-selection-bar/list-selection-bar.component';
import { Pagination2Component } from '@modules/common/components/pagination/pagination2.component';
import { SidebarItemComponent } from '@modules/common/components/sidebar-item/sidebar-item.component';
import { StitchTimestampsComponent } from '@modules/common/components/stitch-timestamps/stitch-timestamps.component';
import { ConnectionsModule } from '@modules/connections/connections.module';
import { DragNDropModule } from '@modules/drag-n-drop/drag-n-drop.module';
import { LinkedInfoListComponent } from '@modules/elements/components/link-info/linked-info-list/linked-info-list.component';
import { EntityHubSearchComponent } from '@modules/elements/components/entity-hub/entity-hub-search/entity-hub-search.component';
import { StitchHubComponent } from '@modules/elements/components/stitch-hub/stitch-hub.component';
import { ProjectQuickFormComponent } from '@modules/elements/components/quick-forms/project-quick-form/project-quick-form.component';
import { QuickFormComponent } from '@modules/elements/components/quick-forms/quick-form/quick-form.component';
import { TaskQuickFormComponent } from '@modules/elements/components/quick-forms/task-quick-form/task-quick-form.component';
import { ProjectContextMenuDirective } from '@modules/elements/directives/project-context-menu.directive';
import { StitchToPopoverDirective } from '@modules/elements/directives/stitch-to-popover.directive';
import { TaskContextMenuDirective } from '@modules/elements/directives/task-context-menu.directive';
import { ElementsModule } from '@modules/elements/elements.module';
import { QuickActionComponent } from '@modules/form-controls/components/quick-action/quick-action.component';
import { FormControlsModule } from '@modules/form-controls/form-controls.module';
import { HeaderDatesComponent } from '@modules/form-controls/elements/header-dates/header-dates.component';
import { KnotsModule } from '@modules/knots/knots.module';
import { ScrollModule } from '@modules/scroll/scroll.module';
import { TagsModule } from '@modules/tags/tags.module';
import { TitleByTasksFilterPipe } from '@modules/tasks/pipes/title-by-tasks-filter.pipe';
import { ToArrayPipe } from '@modules/utils/pipes/array/to-array.pipe';
import { UtilsModule } from '@modules/utils/utils.module';
import { CommonModule as AppCommonModule } from '../common/common.module';
import { BoardTaskComponent } from './components/board-task/board-task.component';
import { ColumnContextMenuComponent } from './components/column-context-menu/column-context-menu.component';
import { ProjectBoardColumnComponent } from './components/project-board-column/project-board-column.component';
import { ProjectBoardRowComponent } from './components/project-board-row/project-board-row.component';
import { ProjectBoardComponent } from './components/project-board/project-board.component';
import { ProjectFormComponent } from './components/project-form/project-form.component';
import { ProjectTasksListColumnComponent } from './components/project-tasks-list-column/project-tasks-list-column.component';
import { ProjectTasksListSectionComponent } from './components/project-tasks-list-section/project-tasks-list-section.component';
import { ProjectTasksListComponent } from './components/project-tasks-list/project-tasks-list.component';
import { ProjectsListContextMenuComponent } from './components/projects-list-context-menu/projects-list-context-menu.component';
import { ProjectsListComponent } from './components/projects-list/projects-list.component';
import { SectionContextMenuComponent } from './components/row-context-menu/row-context-menu.component';
import { SideBarProjectsTreeComponent } from './components/side-bar-projects-tree/side-bar-projects-tree.component';
import { SideBarProjectsComponent } from './components/side-bar-projects/side-bar-projects.component';
import { TasksSideBarComponent } from './components/side-bar/side-bar.component';
import { SidebarContextMenuComponent } from './components/sidebar-context-menu/sidebar-context-menu.component';
import { TaskFormSubtasksComponent } from './components/task-form-subtasks/task-form-subtasks.component';
import { TaskFormComponent } from './components/task-form/task-form.component';
import { RailMenuComponent } from '@modules/common/components/rail-menu/rail-menu.component';
import { TenancySelectorComponent } from '@modules/common/components/tenancy-selector/tenancy-selector.component';
import { TasksListContainerComponent } from './components/tasks-list-container/tasks-list-container.component';
import { TasksListContextMenuComponent } from './components/tasks-list-context-menu/tasks-list-context-menu.component';
import { TasksListComponent } from './components/tasks-list/tasks-list.component';
import { TasksMainViewComponent } from './components/tasks-main-view/tasks-main-view.component';
import { BoardColumnContextMenuDirective } from './directives/board-column-context-menu/board-column-context-menu.directive';
import { ProjectsListContextMenuDirective } from './directives/projects-list-context-menu.directive';
import { SectionContextMenuDirective } from './directives/row-context-menu/row-context-menu.directive';
import { SidebarContextMenuDirective } from './directives/sidebar-context-menu.directive';
import { TasksListContextMenuDirective } from './directives/tasks-list-context-menu.directive';
import { StitchDisplayTimePipe } from './pipes/stitch-display-time.pipe';
import { TaskIssueKeyTitlePipe } from './pipes/task-issue-key-title.pipe';

@NgModule({
  imports: [
    ContainerBadgeComponent,
    HeaderDatesComponent,
    DetailBreadcrumbsComponent,
    SubtaskActionsComponent,
    TaskDispositionComponent,
    TaskWaitingComponent,
    TaskWaitingMarkComponent,
    RowStatusMarkComponent,
    ItemReviewComponent,
    TaskHandoverComponent,
    HandoverAssignButtonComponent,
    CanPurgeTeamItemPipe,
    SearchLocationBadgeComponent,
    AppCommonModule,
    BundledInputsModule,
    CommentsModule,
    CommonModule,
    ConnectionsModule,
    DragNDropModule,
    ElementsModule,
    FormControlsModule,
    FormsModule,
    KnotsModule,
    MatIconModule,
    MatTooltipModule,
    ContextMenuDividerComponent,
    ContextMenuHeadingComponent,
    ContextMenuItemComponent,
    ContextMenuStateIndicatorComponent,
    PopoverDirective,
    ReactiveFormsModule,
    ScrollModule,
    ScrollingModule,
    TagsModule,
    UtilsModule,
    ListLoadErrorComponent,
    NoContentStubComponent,
    LoadingIndicatorComponent,
    ListItemSeparatorComponent,
    ListSelectionBarComponent,
    Pagination2Component,
    Checkbox2Component,
    QuickActionComponent,
    ItemDescriptionFieldComponent,
    ToArrayPipe,
    TaskContextMenuDirective,
    ProjectContextMenuDirective,
    RailMenuComponent,
    StitchToPopoverDirective,
    LinkedInfoListComponent,
    EntityHubSearchComponent,
    StitchHubComponent,
    TaskQuickFormComponent,
    QuickFormComponent,
    ProjectQuickFormComponent,
    SidebarItemComponent,
    Button2Component,
    IconComponent,
    StitchDisplayTimePipe,
    TaskIssueKeyTitlePipe,
    DropdownInputComponent,
    StitchTimestampsComponent,
    InitialsCircleComponent,
    ToggleSwitch2Component,
    TenancySelectorComponent,
  ],
  declarations: [
    BoardTaskComponent,
    ColumnContextMenuComponent,
    ProjectBoardColumnComponent,
    ProjectBoardComponent,
    ProjectBoardRowComponent,
    ProjectFormComponent,
    ProjectTasksListColumnComponent,
    ProjectTasksListComponent,
    ProjectTasksListSectionComponent,
    ProjectsListComponent,
    ProjectsListContextMenuComponent,
    SectionContextMenuComponent,
    SideBarProjectsComponent,
    SideBarProjectsTreeComponent,
    SidebarContextMenuComponent,
    SidebarContextMenuDirective,
    TaskFormComponent,
    TaskFormSubtasksComponent,
    TasksListComponent,
    TasksListContainerComponent,
    TasksListContextMenuComponent,
    TasksMainViewComponent,
    TasksSideBarComponent,

    // Directives
    BoardColumnContextMenuDirective,
    ProjectsListContextMenuDirective,
    SectionContextMenuDirective,
    TasksListContextMenuDirective,

    // Pipes
    TitleByTasksFilterPipe,
  ],
  exports: [
    ProjectsListComponent,
    TasksMainViewComponent,
    TasksListComponent,
    TasksListContainerComponent,
    TasksSideBarComponent,
    TaskFormComponent,
    TaskFormSubtasksComponent,
    ProjectFormComponent,

    // Directives
    ProjectsListContextMenuDirective,
    TasksListContextMenuDirective,
    TitleByTasksFilterPipe,
  ],
  providers: [],
})
export class TasksModule {}
